document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-spritz-botanicals-slider]');

  for (const slider of sliders) {
    if (slider._spritzSliderInit) continue;
    slider._spritzSliderInit = true;

    let swiperInstance = null;
    let resizeRaf = null;

    const toggleSlider = () => {
      if (window.innerWidth >= 1024) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }

        return;
      }

      if (swiperInstance) return;

      swiperInstance = new Swiper(slider, {
        slidesPerView: 1.75,
        spaceBetween: 16,
        slidesOffsetBefore: 30,
        slidesOffsetAfter: 30,
        centeredSlides: false,
        allowTouchMove: true,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          640: { slidesPerView: 1.75, spaceBetween: 16 },
          769: { slidesPerView: 2.75, spaceBetween: 16 }
        }
      });
    };

    toggleSlider();

    window.addEventListener('resize', () => {
      if (resizeRaf) {
        window.cancelAnimationFrame(resizeRaf);
      }

      resizeRaf = window.requestAnimationFrame(() => {
        toggleSlider();
      });
    });
  }
});
